import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../dynamicFormBuilder/FormField';
import ItemMasterFormLayout from './ItemMasterFormLayout';
import {
    GetLookupData, GetSalesOrderGridData, GetOrderDetailGridData, GetArOpenItemGridData
    , GetItemMasterGridData, GetItemMasterMainGridData, GetLookupStaticData
} from "../../../../services/SalesOrderService";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const ItemMasterFilters  = (props) => {
  
    const [selectedItems, setSelectedItems] = useState([]);

    const [forceRender, setForceRender] = useState(false);
    const initialFormFields = {
        WarehouseID: '',
        ItemCode: '',
        Description_1: '',
        Description_2: '',
        ClassCode: '',
        SubClassCode: '',
        Available: 0,
        DateAvailable: '',
        AverageCost: 0,
        BomExplosionFlag: '',
        UserDefinedCode1: '',
        UserDefinedCode2: '',
        UserDefinedCode3: '',
        UserDefinedCode4: '',
        UserDefinedCode5: '',
        UserDefinedCode6: '',
        UserDefinedCode7: '',
        UserDefinedCode8: '',
        UserDefinedCode9: '',
        UserDefinedCode10: '',
        CreationUserId: '',
        CreationDateTime: '',
        LastUpdateDateTime: '',
        UserDefinedDate1: '',
        UserDefinedDate2: '',
        UserDefinedDate3: '',
        UserDefinedDate4: '',
        UserDefinedDate5: '',
        UserDefinedDate6: '',
        UserDefinedDate7: '',
        UserDefinedDate8: '',
        UserDefinedDate9: '',
        UserDefinedDate10: '',
        DateExpiration: '',
        InReceiving: '',
        CareInstructions: '',
        DateIntroduced: '',
        InventoryUnitUom: '',
        ItemSourceFlag: '',
        ItemType: '',
        LastCost: '',
        LastUpdateUserId: '',
        PriceLevelA: 0,
        PriceLevelB: 0,
        PriceLevelC: 0,
        PriceLevelD: 0,
        PriceLevelE: 0,
        Status: '',
        UserDefinedQuantity1: 0,
        UserDefinedQuantity2: 0,
        UserDefinedQuantity3: 0,
        UserDefinedQuantity4: 0,
        UserDefinedQuantity5: 0,
        UserDefinedQuantity6: 0,
        UserDefinedQuantity7: 0,
        UserDefinedQuantity8: 0,
        UserDefinedQuantity9: 0,
        UserDefinedQuantity10: 0,
        UserDefinedReference1: '',
        UserDefinedReference2: '',
        UserDefinedReference3: '',
        UserDefinedReference4: '',
        UserDefinedReference5: '',
        UserDefinedReference6: '',
        UserDefinedReference7: '',
        UserDefinedReference8: '',
        UserDefinedReference9: '',
        UserDefinedReference10: '',
        DateExpiration: '',
        CareInstructions: '',
        DateIntroduced: '',
        InventoryUnitUom: '',
        OnHand: 0,
        WearHouseName: '',
        Locationmaxunitsforwardpick: 0,
        Locationmaxunitsreplenishment: 0,
        Minimumsalesquantity: 0,
        Locationminunitsforwardpick: 0,
        Locationminunitsreplenishment: 0,
        WarehouseID: '',
    };

    const StatusOptions = [
        { ID: 'A', Text: "Active" },
        { ID: 'I', Text: "In Active" }
        // { ID: 'O', Text: "Open" },
        // { ID: 'H', Text: "Hold" },
        // { ID: 'L', Text: "Ready To Commit Later" },
        // { ID: 'N', Text: "Ready To Commit Now" },
        // { ID: 'Z', Text: "Committed" },
    ]
    const [formFields, setformFields] = useState(initialFormFields);



    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );
    const handleFormSubmit = (e) => {
        props.searchData(formFields);
    };
    const handleFieldChange = useCallback((name, value) => {
        console.log(name, value)

    }, []);
    const handleReset = () => {
        setformFields(initialFormFields);
    };
    const formRefs = useRef({});
    const handleSalesOrderSearchFormLoad = useCallback(() => {
        GetLookupStaticData("Status", StatusOptions, formRefs, setForceRender, forceRender);
        //GetLookupData("R_CUSTOMER", getCustomerUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
    }, []);


    return (
            <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                        selectionChanged(e, e.target);
                    }
                }}
                itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2
                                    }}
                                >
                                    {'OM Sales Orders Management (Item Master)'}
                                </h6>
                            </div>
                        </Item>

                        <Item location="after">
                            <Button className="accordianButton" onClick={handleFormSubmit} text="Search" type="default" />
                        </Item>
                        <Item location="after">
                            <Button className="accordianButton" onClick={handleReset} text="Reset" />
                        </Item>
                    </Toolbar>
                )}
                itemRender={(itemProps) => (
                    <div >
                        <FormField
                            currrentUser={props.currentUser}
                            layoutId='B2DDDC27-B57E-447F-89DC-BB2B44AEE60D'
                            layoutName='MyTestForm'
                            defaultFormSchema={ItemMasterFormLayout}
                            formFields={formFields}
                            setformFields={setformFields}
                            handleFieldValueChange={handleFieldChange}
                            DYNAMICFORMSETTING={props.DYNAMICFORMSETTING}
                            formRefs={formRefs}
                            onFormLoad={handleSalesOrderSearchFormLoad}
                            noSpacingBeforeFirstRow={true}
                        />

                    </div>
                )}
                id="accordion-container" className="accordion-height"
            />
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemMasterFilters );